import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const GlosaFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='input-glosa' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='glosa'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-glosa'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
